import { connect } from 'react-redux'
import { Unlock } from './Reset'
export { Unlock }
export default connect(({tokens}) => tokens)(Unlock)